import axios from 'axios';
import {apiUrl} from "../../constants/config";

export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getAccount({}, params) {
            return new Promise((resolve, reject) => {
                axios.get(apiUrl + 'api/account/' + params.code + '/' + params.id).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        requestMethod({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/account/' + payload.code + '/' + payload.id + '/method', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        },
        changeMethod({}, secret) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/account/approve_m', {secret: secret}).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response);
                });
            });
        },
        updateName({}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(apiUrl + 'api/account/' + payload.code + '/' + payload.id + '/name', payload).then(response => {
                    resolve(response.data);
                }, err => {
                    console.log(err);
                    reject(err.response.data);
                });
            });
        }
    }
}
